import { api } from "../app";
import { dimmer } from "./dimmer";
const defaultContext = $("body");

export const binaryUpload = (formData, context = defaultContext, data, bustCache = false) => {
	context.append(dimmer());
	return new Promise(async (resolve, reject) => {
		try {
			const response = await $.ajax({
				method: "POST",
				url: `${api}/request`,
				contentType: false,
				processData: false,
				cache: false,
				forceSynce: false,
				xhrFields: {
					withCredentials: true
				},
				data: formData
			});
			context.find(".dimmer").remove();
			if (response.success) {
				if (bustCache) {
					await invalidateCache(bustCache, context);
				}
				resolve(response);
			} else {
				resolve(response);
			}
		} catch (err) {
			context.find(".dimmer").remove();
			console.error("Error with binary upload request");
			reject(err);
		}
	});
};
// end binaryUpload method

function invalidateCache(params, context = defaultContext) {
	params.reqId = "01074ae2-32bb-4475-8aed-0b4faf6fc493";
	// purgeCloudFrontCachePvt

	params.distroId = params.distroId ? params.distroId : "EIQONYATJLYCL";
	// default distro is gulftreamnews-data

	return new Promise(async (resolve, reject) => {
		try {
			context.append(dimmer());
			const response = await $.ajax({
				method: "POST",
				url: `${api}/request`,
				headers: {
					"Content-Type": "application/json"
				},
				xhrFields: {
					withCredentials: true
				},
				data: JSON.stringify(params)
			});
			context.find(".dimmer").remove();
			if (response.success) {
				resolve("Data cache purged");
			} else {
				throw response.data;
			}
		} catch (err) {
			context.find(".dimmer").remove();
			reject(err);
		}
	});
}
